module.exports = __webpack_public_path__ + "img/login_img.438bc03d.jpg";